export const MainBarActiveTabsAction = (data) => {
    return({
        type: 'MainBarActiveTabs',
        payload: data
    })
}